import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed lg:top-[72px] top-16 bg-white z-10 mb-6 shadow-[0_1px_0px_0px_rgba(0,0,0,0.08)] -mx-4 w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Back", -1)
const _hoisted_3 = { class: "grid lg:grid-cols-[210px_auto] grid-cols-1 mt-16" }
const _hoisted_4 = { class: "lg:sticky top-8 col-span-1 lg:my-11 my-4" }
const _hoisted_5 = { class: "flex flex-col space-y-2" }
const _hoisted_6 = { class: "lg:my-11 lg:max-w-[950px] lg:pl-[60px]" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "py-6" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "py-6" }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "py-6" }

import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import UserLayout from '@/layouts/UserLayout.vue';
import SectionTitle from '@/components/partials/SectionTitle.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import TabComponent from '@/components/partials/TabComponent.vue';
import PasswordInput from '@/components/inputs/PasswordInput.vue';

import ProfileFormSection from './profiles/FormSection.vue';
import PasswordFormSection from './passwords/FormSection.vue';
import PinFormSection from './pins/FormSection.vue';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import SuccessModal from '@/components/modals/SuccessModal.vue';

import Profile from "@/classes/Profile";

import assignValues from "@/helpers/assignValues"
import ArrowLeftIcon from "@/components/icons/arrowLeftIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);

const tabs: { name: string, count: number, href: string, allowed: boolean }[] = [
    {
        name: 'Profile',
        count: 0,
        href: "/profile",
        allowed: true
    },
    {
        name: 'Password',
        count: 0,
        href: "/profile?tab=password",
        allowed: true
    },
    {
        name: 'PIN',
        count: 0,
        href: "/profile?tab=pin",
        allowed: true
    }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
        }, [
          _createVNode(ButtonComponent, { customClass: "tertiary text-black hover:text-primary-600 transition py-4" }, {
            default: _withCtx(() => [
              _createVNode(ArrowLeftIcon, { class: "object-contain w-6 h-6 mr-2" }),
              _hoisted_2
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(TabComponent, {
              tabs: tabs,
              typeTwo: ""
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_unref(route).query.tab != 'password' && _unref(route).query.tab != 'pin')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(SectionTitle, {
                  title: "Profile",
                  description: "View the relevant data and other details"
                }),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(ProfileFormSection)
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(route).query.tab == 'password')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(SectionTitle, {
                  title: "Password",
                  description: "View the relevant data and other details"
                }),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(PasswordFormSection)
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(route).query.tab == 'pin')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(SectionTitle, {
                  title: "PIN",
                  description: "View the relevant data and other details"
                }),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(PinFormSection)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})